export function Caret({
  strokeWidth = 1.5,
  ...rest
}: React.SVGProps<SVGSVGElement> & { strokeWidth?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.065 6.593"
      height="1em"
      width="1em"
      {...rest}
    >
      <title>Caret</title>
      <path
        id="Pfad_2970"
        data-name="Pfad 2970"
        d="M1451.645,3315.879l5,5-5,5"
        transform="translate(3326.414 -1451.115) rotate(90)"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
